'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { installKakaobankInterface, openKakaobankDocs } from '../_utils/appBridge';

//* 규격이 색을 hex로 받는다 — DS Button 기본 테마와 같은 Gray-black/white 값이다
const DOCS_BUTTON_BACKGROUND_COLOR = '#000000';
const DOCS_BUTTON_TEXT_COLOR = '#ffffff';
const readExternalUrl = (anchor: HTMLAnchorElement) => {
  const href = anchor.getAttribute('href');
  if (!href) {
    return undefined;
  }
  try {
    const url = new URL(href, window.location.href);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return undefined;
    }
    return url.origin === window.location.origin ? undefined : url;
  } catch {
    return undefined;
  }
};

//* 카뱅 웹뷰는 우리 오리진 밖으로 나가면 크롬도 onBackPressed도 잃는다(iOS는 진입 자체가 막힌다)
//* — 본문 HTML의 링크는 우리가 심을 수 없으니 클릭을 위임으로 받아 규격 문서뷰로 넘긴다
export const KakaobankExternalLinkController = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
};
function _temp(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }
  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }
  const anchor = target.closest("a");
  if (!(anchor instanceof HTMLAnchorElement)) {
    return;
  }
  const url = readExternalUrl(anchor);
  if (!url) {
    return;
  }
  installKakaobankInterface();
  if (typeof window.KabangB2bJavascriptInterface?.openDocs !== "function") {
    return;
  }
  event.preventDefault();
  openKakaobankDocs({
    title: anchor.textContent?.trim() || url.hostname,
    url: url.href,
    buttonBackgroundColor: DOCS_BUTTON_BACKGROUND_COLOR,
    buttonTextColor: DOCS_BUTTON_TEXT_COLOR
  });
}
function _temp2() {
  const handleClick = _temp;
  document.addEventListener("click", handleClick);
  return () => {
    document.removeEventListener("click", handleClick);
  };
}